import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractStudentFeeMenuComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import * as SVG from '~/assets/svg'
import { Loading } from '~/components/loader'
import { withTranslation } from 'react-i18next'

class StudentFeeMenuComponent extends AbstractStudentFeeMenuComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Sidebar id="fee" />
                <Loading status={this.state.loading} text="Loading" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>{t('fee:fee')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-5 float-left">
                                {/* <span className="sub-main-title">{t('fee:menu')}</span> */}
                                <h5 className="main-title heading5">{t('fee:fee')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="folder-page">
                        <div className="row clearfix">
                            <div className="float-left  course-your">
                                <div className="folder-list clearfix" onClick={() => (window.location = route.student_fee.upcoming)}>
                                    <a href={route.student_fee.upcoming} className="folder-img">
                                        {SVG.feeCollectIcon()}
                                    </a>
                                    <a href={route.student_fee.upcoming} className="folder-name">
                                        {t('fee:upcoming_payment')}
                                        <span>{t('fee:manage_msg')}</span>
                                    </a>
                                </div>
                            </div>
                            <div className="float-left course-your">
                                <div className="folder-list clearfix" onClick={() => (window.location = route.student_fee.statement.search)}>
                                    <a href={route.student_fee.statement.search} className="folder-img">
                                        {SVG.invoiceIcon()}
                                    </a>
                                    <a href={route.student_fee.statement.search} className="folder-name">
                                        {t('fee:invoice')}
                                        <span>{t('fee:manage_msg')}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const StudentFeeMenu = withTranslation()(connect(mapStateToProps)(StudentFeeMenuComponent))

export { StudentFeeMenu }
